/* eslint-disable */
// @ts-nocheck I don't think this file is really being used anyways
// Generated by CoffeeScript 2.5.1
(function() {
  var DistrictMap, featureFlagHelpers, isFeatureEnabled,
    indexOf = [].indexOf;

  featureFlagHelpers = require("shared/featureflags/helperFunctions.js");

  isFeatureEnabled = featureFlagHelpers.isFeatureEnabled;

  DistrictMap = function(userdata, selector) {
    var abbrev_to_db_id, abbrev_to_state_id, active_view, add_leading_digits, address, allow_panning, allowed_states, api_key, chamber, check_district, congress, current_regions, dem_color, district, district_borders_g, district_tag, districts, districts_g, draw_cities, draw_map, enable_district, filter_dict, first_count, first_load, handle_address_success, height, highlight_color, id_to_state, ind_color, initialized, legislators, load_data, load_districts, map, margin, maximum_results, member_boxes, non_selected_color, one_district, page, party, party_colors, path, pinpoint_stroke, projection, receive_address, repub_color, reset_zoom, scale, search_term, selected_address, selected_district, selected_legislators, selected_state, selected_state_color, show_legislators, show_max, show_min, show_total, sort_search, state, state_color_aux, state_color_default, state_lds, state_mapping, state_options, states_borders_g, states_g, svg, text_adj, text_fill_adj, top_cities, total_count, update, update_filter, update_map, us, view_change, width, wrapper_g, zoom;
    // global variables
    margin = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
    width = document.getElementById(selector).offsetWidth - margin.left - margin.right;
    height = 390;
    show_total = 18;
    show_min = 0;
    show_max = show_total;
    id_to_state = {};
    party_colors = function(d) {
      var colors;
      colors = ['#1f77b4', '#d62728', '#8c564b'];
      if (d['party'] === 'Democrat') {
        return colors[0];
      } else if (d['party'] === 'publican') {
        return colors[1];
      } else {
        return colors[2];
      }
    };
    highlight_color = '#503ABD';
    non_selected_color = '#aaa';
    selected_state_color = '#4D2D5F';
    state_color_default = '#fff'; //white
    state_color_aux = '#7b8a8b'; //dark gray
    pinpoint_stroke = '#fff'; //white
    repub_color = '#d62728'; //red
    dem_color = '#1f77b4'; //blue
    ind_color = '#8c564b'; //brown
    scale = 1;
    projection = d3.geo.albersUsa().scale(2 * height).translate([width / 2, height / 2.02]);
    path = d3.geo.path().projection(projection);
    // adjustments for state labels
    text_adj = {
      6: [
        width,
        30 //CA
      ],
      9: [
        30,
        30 //CT
      ],
      10: [
        30,
        50 //DE
      ],
      11: [
        11,
        50 //DC
      ],
      12: [
        80,
        100 //FL
      ],
      15: [
        45,
        -height //HI
      ],
      21: [
        100,
        height //KY
      ],
      22: [
        -100,
        -height //LA
      ],
      24: [
        20,
        20 //MD
      ],
      25: [
        25,
        -100 //MA
      ],
      26: [
        80,
        17 //MI
      ],
      33: [
        20,
        2500 //NH
      ],
      34: [
        30,
        100 //NJ
      ],
      36: [
        120,
        height //NY
      ],
      44: [
        25,
        100 //RI
      ],
      47: [
        width,
        90 //TN
      ],
      50: [
        -100,
        -20 //VT
      ]
    };

    // state text fill adjustments for CT, DE, DC, HI, MD MA, NH, NJ, RI, VT
    text_fill_adj = [9, 10, 11, 15, 24, 25, 33, 34, 44, 50];
    // single-district states AK, DE, DC, MT, ND, SD, VT, WY
    one_district = [200, 1000, 1198, 3000, 3800, 4600, 5000, 5600];
    // API key for Sunlight Foundation district locating
    api_key = "bee26b52d4974d7683db2000ae00ec63";
    // svg groups for axes, etc.
    svg = null;
    wrapper_g = null;
    states_g = null;
    states_borders_g = null;
    districts_g = null;
    district_borders_g = null;
    member_boxes = null;
    // new state options
    active_view = "";
    allow_panning = true;
    view_change = false;
    state_lds = {};
    allowed_states = {};
    userdata = Userdata;
    current_regions = userdata.current_regions;
    first_load = true;
    state_options = ["sldu", "sldl"];
    state = '';
    first_count = true;
    maximum_results = 0;
    total_count = 0;
    abbrev_to_state_id = {
      "DK": null,
      "WA": "53",
      "VA": "51",
      "DE": "10",
      "DC": "11",
      "WI": "55",
      "WV": "54",
      "HI": "15",
      "FL": "12",
      "WY": "56",
      "NH": "33",
      "NJ": "34",
      "NM": "35",
      "TX": "48",
      "LA": "22",
      "NC": "37",
      "ND": "38",
      "NE": "31",
      "TN": "47",
      "NY": "36",
      "PA": "42",
      "PI": null,
      "CA": "06",
      "NV": "32",
      "PR": "72",
      "GU": "66",
      "CO": "08",
      "VI": "78",
      "AK": "02",
      "AL": "01",
      "AS": "60",
      "AR": "05",
      "VT": "50",
      "IL": "17",
      "GA": "13",
      "IN": "18",
      "IA": "19",
      "OK": "40",
      "AZ": "04",
      "ID": "16",
      "CT": "09",
      "ME": "23",
      "MD": "24",
      "OL": null,
      "MA": "25",
      "OH": "39",
      "UT": "49",
      "MO": "29",
      "MN": "27",
      "MI": "26",
      "RI": "44",
      "KS": "20",
      "MT": "30",
      "MP": "69",
      "MS": "28",
      "SC": "45",
      "KY": "21",
      "OR": "41",
      "SD": "46"
    };
    abbrev_to_db_id = {
      'WA': 48,
      'VA': 47,
      'DE': 8,
      'DC': 9,
      'WI': 50,
      'WV': 49,
      'HI': 12,
      'FL': 10,
      'WY': 51,
      'NH': 30,
      'NJ': 31,
      'NM': 32,
      'TX': 44,
      'LA': 19,
      'NC': 34,
      'ND': 35,
      'NE': 28,
      'TN': 43,
      'NY': 33,
      'PA': 39,
      'CA': 5,
      'NV': 29,
      'PR': 54,
      'GU': 57,
      'CO': 6,
      'VI': 53,
      'AK': 2,
      'AL': 1,
      'AS': 56,
      'AR': 4,
      'VT': 46,
      'IL': 14,
      'GA': 11,
      'IN': 15,
      'IA': 16,
      'OK': 37,
      'AZ': 3,
      'ID': 13,
      'CT': 7,
      'ME': 20,
      'MD': 21,
      'MA': 22,
      'OH': 36,
      'UT': 45,
      'MO': 26,
      'MN': 24,
      'MI': 23,
      'RI': 40,
      'KS': 17,
      'MT': 27,
      'MP': 55,
      'MS': 25,
      'SC': 41,
      'KY': 18,
      'OR': 38,
      'SD': 42
    };
    // datasets
    us = null;
    state_mapping = {};
    districts = null;
    legislators = [];
    selected_legislators = [];
    show_legislators = [];
    top_cities = null;
    // variables that reflect the current state of the visualization
    initialized = false;
    congress = 114;
    district = '';
    party = '';
    chamber = '';
    search_term = '';
    selected_state = null;
    selected_district = null;
    page = '';
    sort_search = 'lastname';
    address = '';
    selected_address = '';
    district_tag = '';
    // filter dict to pass back to Pie
    filter_dict = {};
    // Choose what options to allow, give what features they have enabled
    if (Userdata.isOnlyFederalMode()) {
      active_view = "CD";
      chamber = "fedboth";
      $(".states-option").addClass("not-active");
      $("#everyone").addClass("not-active");
      $("#chamber_select").val(chamber).trigger("change");
    } else if (current_regions !== ["all"]) {
      active_view = "stateboth";
      chamber = active_view;
      $(".all-option").addClass("not-active");
      $(".us-option").addClass("not-active");
      $("#chamber_select").val(active_view).trigger("change");
      // IF only one state lock it in
      if (Userdata.isSingleRegionMode()) {
        allow_panning = false;
        state = current_regions[0].toUpperCase();
        $("#state_select").val(`${state}`).prop("disabled", true).trigger("change");
        if (current_regions === ["ne"] || current_regions === ["dc"]) {
          // When in state mode chamber becomes change views
          // d3.selectAll("#LD-option").classed("not-active", true)
          active_view = "sldu";
          $("#chamber_select").val(active_view).prop("disabled", true).trigger("change");
        }
      }
    } else {
      active_view = "everyone";
      chamber = "everyone";
    }
    // initialize visualization
    map = function(selection) {
      if (!initialized) {
        // make the svg object and add a rectangle for zooming
        svg = d3.select(selection).append("svg").attr("width", width).attr("height", height);
        svg.append("rect").attr("class", "adv-src-background").attr("width", width).attr("height", height).on("click", zoom);
        // hide notification for no address found
        d3.select('#no_address').style("display", "none");
        // make an svg group to go around the whole map to allow for zooming
        wrapper_g = svg.append("g").attr("transform", "translate(0,0)scale(1,1)");
        // define a queue to load in all the data, which will eventually draw everything
        queue().defer(d3.json, STATIC_URL + "data/maps/us.static").defer(d3.json, STATIC_URL + ((isFeatureEnabled("ff_district_tab_map_congress_116_file")) ? "data/maps/us-congress-116.static" : "data/maps/us-congress-113.static")).defer(d3.json, STATIC_URL + "data/maps/fips_mapping.static").defer(d3.json, STATIC_URL + "data/maps/top_735_cities_0.static").await(load_data);
        return initialized = true;
      }
    };
    // data loading function
    load_data = function(error, state_data, district_data, fips_mapping_data, top_735_cities) {
      var key;
      // store all data as a global variable
      us = state_data;
      districts = district_data;
      state_mapping = fips_mapping_data;
      top_cities = top_735_cities;
      for (key in fips_mapping_data) {
        id_to_state[+fips_mapping_data[key]] = key;
      }
      // draw the map and update
      draw_map();
      return update_filter();
    };
    // function that draws the initial states
    draw_map = function() {
      var state_g;
      svg.append("defs").append("path").attr("id", "land").datum(topojson.feature(us, us.objects.land)).attr("d", path);
      // clip around the given object to make sure districts don't exceed the edges
      svg.append("clipPath").attr("id", "clip-land").append("use").attr("xlink:href", "#land");
      districts_g = wrapper_g.append("g").attr("class", "districts").attr("clip-path", "url(#clip-land)").selectAll("path");
      district_borders_g = wrapper_g.append("path").attr("class", "district-boundaries");
      // add another svg group for the states
      states_g = wrapper_g.append("g").attr("class", "states");
      state_g = states_g.selectAll("g").data(topojson.feature(us, us.objects.states).features).enter().append("g").classed("state", true).style("fill", non_selected_color);
      if (allow_panning) {
        state_g = state_g.on("click", zoom).on("mouseover", function(d) {
          return d3.select(this).style("fill", highlight_color);
        }).on("mouseout", function(d) {
          return d3.select(this).style("fill", non_selected_color);
        });
      }
      state_g.append("path").attr("d", path).attr("id", function(d) {
        return 'id_' + String(d.id);
      });
      // adjusts state labels based on screen size, stays proportional
      state_g.append("text").text(function(d) {
        return id_to_state[d.id];
      }).attr('font-size', '0.8em').attr("x", function(d) {
        if (d.id in text_adj) {
          return path.centroid(d)[0] + width / text_adj[d.id][0];
        } else {
          return path.centroid(d)[0];
        }
      }).attr("y", function(d) {
        if (d.id in text_adj) {
          return path.centroid(d)[1] + height / text_adj[d.id][1];
        } else {
          return path.centroid(d)[1];
        }
      }).attr("text-anchor", "middle").style("fill", function(d) {
        var ref;
        if (ref = d.id, indexOf.call(text_fill_adj, ref) >= 0) {
          return state_color_aux;
        } else {
          return state_color_default;
        }
      }).on("mouseover", function(d) {
        var ref;
        if (ref = d.id, indexOf.call(text_fill_adj, ref) >= 0) {
          return d3.select(this).style("fill", highlight_color);
        }
      }).on("mouseout", function(d) {
        var ref;
        if (ref = d.id, indexOf.call(text_fill_adj, ref) >= 0) {
          return d3.select(this).style("fill", state_color_aux);
        }
      });
      // now add the state borders
      states_borders_g = wrapper_g.append("path").datum(topojson.mesh(us, us.objects.states, function(a, b) {
        return a !== b;
      })).attr("class", "state-borders").attr("d", path);
      d3.select(".currently-selected").html('<hr> <span class="title">Currently Selected:</span> <h3><span id="currently_selected">All</span></h3> <hr>');
      if (state !== "") {
        update();
      }
      if (QueryString["state"] != null) {
        return map.set_state(QueryString["state"]);
      }
    };
    handle_address_success = function(latitude, longitude) {
      return [latitude, longitude];
    };
    window.google_maps_request = function(address) {
      var deferred, geocoder;
      deferred = $.Deferred();
      geocoder = new google.maps.Geocoder();
      geocoder.geocode({
        'address': address
      }, function(results, status) {
        var latitude, longitude;
        if (status === google.maps.GeocoderStatus.OK) {
          latitude = results[0].geometry.location.lat();
          longitude = results[0].geometry.location.lng();
          return deferred.resolve(handle_address_success(latitude, longitude));
        } else {
          return deferred.reject(status);
        }
      });
      return deferred.promise();
    };
    receive_address = function(latLongResults) {
      var latitude, longitude, state_selector, state_url, url;
      latitude = latLongResults[0];
      longitude = latLongResults[1];
      // if address is found...
      if (projection([longitude, latitude]) != null) {
        // remove pinpoint
        wrapper_g.selectAll("circle").remove();
        state_url = false;
        // zooms in as best as we can to location
        if (chamber === "everyone" || chamber === "fedboth" || chamber === "stateboth" || chamber === "house" || chamber === "senate") {
          url = "https://congress.api.sunlightfoundation.com/districts/locate?apikey=" + api_key + "&latitude=" + String(latitude) + "&longitude=" + String(longitude);
        } else {
          state_url = true;
          url = `http://openstates.org/api/v1/legislators/geo/?lat=${latitude}&long=${longitude}&apikey=${api_key}`;
        }
        d3.json(url, function(json) {
          var data, district_selector, new_state, state_selector;
          // Turn this on when district filter works
          // address = ""
          // set address button back to "Submit"
          // $('#address_search_button').html("Submit")
          if (state_url) {
            if (json.length === void 0 || json.length < 1) {
              return wrapper_g.selectAll("circle").remove();
            } else if (json.length > 0) {
              if (active_view !== "sldu" && json.length === 1) {
                active_view = "sldu";
              }
              // Filter
              data = json.filter(function(d) {
                if (active_view === "sldu") {
                  return d.chamber === "upper";
                } else {
                  return d.chamber === "lower";
                }
              })[0];
              // Get possible states
              new_state = data.state.toUpperCase();
              // If it is a new state, pick it
              if (new_state !== state && !Userdata.isSingleRegionMode()) {
                state = new_state;
                state_selector = "#id_" + String(parseInt(state_mapping[state]));
                d3.selectAll(state_selector).each(function(d) {
                  return zoom(d);
                });
              }
              return district = add_leading_digit(String(state_mapping[state]), 2) + add_leading_digits(String(d.district), 3);
            }
          } else {
            // If you are not viewing a state
            new_state = json.results[0].state;
            if (new_state !== state && !Userdata.isSingleRegionMode()) {
              state = new_state;
              state_selector = "#id_" + String(parseInt(state_mapping[state]));
              d3.selectAll(state_selector).each(function(d) {
                return zoom(d);
              });
            } else if (Userdata.isSingleRegionMode()) {
              wrapper_g.selectAll("circle").remove();
            }
            if (active_view !== "CD") {
              return wrapper_g.selectAll("circle").remove();
            } else {
              // set address button back to "Submit"
              if (json.results[0].district < 10) {
                district = "0" + String(json.results[0].district);
              } else {
                district = String(json.results[0].district);
              }
              district_tag = String(+state_mapping[state]) + district;
              district_selector = "#id_" + district_tag;
              selected_district = d3.selectAll(district_selector).each(function(d) {
                return check_district(d);
              });
              return wrapper_g.append("circle").attr("id", "pin-drop").attr("r", 3).attr("stroke", pinpoint_stroke).attr("stroke-width", 1);
            }
          }
        });
        // select state of location and zoom
        state_selector = "#id_" + String(state_mapping[state]);
        return d3.selectAll(state_selector).each(function(d) {
          return zoom(d);
        });
      } else {
        return reset_zoom();
      }
    };
    update_map = function() {
      // determine if an address is input, then finds state/district of address
      if (address !== '' && address !== selected_address) {
        selected_address = address;
        return google_maps_request(selected_address).then((data) => {
          return receive_address(data);
        }, (err) => {
          // notify if no address is found
          wrapper_g.selectAll("circle").remove();
          return reset_zoom();
        });
      } else {
        wrapper_g.selectAll("circle").remove();
        // determine if state is selected and zoom to that state, else reset zoom
        if (state !== '') {
          if (state_mapping[state] < 10) {
            selector = "#id_" + String(state_mapping[state])[1];
          } else {
            selector = "#id_" + String(state_mapping[state]);
          }
          return d3.selectAll(selector).each(function(d) {
            return zoom(d);
          });
        } else {
          return reset_zoom();
        }
      }
    };
    // update function
    update_filter = function() {
      var dist_fips, i, key, len, ref;
      filter_dict = {
        representing_state: void 0,
        most_recent_upper_district__fips_code: void 0,
        most_recent_lower_district__full_fips_string: void 0,
        most_recent_district__fips_code: void 0,
        representing_address: void 0
      };
      if (state !== "") {
        filter_dict["representing_state"] = abbrev_to_db_id[state];
      }
      if (district !== "") {
        if (district < 100) {
          dist_fips = abbrev_to_state_id[state] + add_leading_digits(String(district), 2);
        } else {
          dist_fips = district;
        }
        if (chamber === "sldu") {
          filter_dict["most_recent_upper_district__fips_code"] = dist_fips;
          filter_dict["representing_state"] = void 0;
        } else if (chamber === "sldl") {
          filter_dict["most_recent_lower_district__full_fips_string"] = dist_fips;
          filter_dict["representing_state"] = void 0;
        } else if (chamber === "fedboth" || chamber === "house" || chamber === "senate") {
          filter_dict["most_recent_district__fips_code"] = dist_fips;
          filter_dict["representing_state"] = void 0;
        }
      }
      if (address !== "") {
        ref = Object.keys(filter_dict);
        for (i = 0, len = ref.length; i < len; i++) {
          key = ref[i];
          (key !== 'representing_address' ? filter_dict[key] = void 0 : void 0);
        }
        return filter_dict['representing_address'] = address;
      }
    };
    update = function() {
      // updates both the map and the filter when passed new options
      update_filter();
      return update_map();
    };
    // zooming functions from http://bl.ocks.org/mbostock/4699541
    zoom = function(d) {
      var district_data, load_time, z_duration;
      if (d == null) {
        if (!Userdata.isSingleRegionMode()) {
          return reset_zoom();
        }
      } else {
        // make zoom-out button visible (if not viewing single state)
        if (allow_panning) {
          d3.select("#zoom-out").style("display", "inline");
        }
        // save the selected state
        selected_state = d;
        state = id_to_state[selected_state.id];
        district = '';
        // update currently selected
        d3.select(".currently-selected").html('<hr> <span class="title">Currently Selected:</span> <h3><span id="currently_selected">' + state + '</span></h3> <hr>');
        // set all states other than the select state to inactive (if not view all)
        if (active_view !== "stateboth" && active_view !== "" && active_view !== "everyone") {
          wrapper_g.selectAll(".state").classed("active", selected_state && function(d) {
            return d === selected_state;
          }).classed("shape-on", selected_state && function(d) {
            return d === selected_state;
          });
          // remove all prexisting district data
          d3.selectAll('.district').remove();
          if (district_borders_g) {
            district_borders_g.attr("d", "");
          }
          // add in a svg group for the districts
          load_time = 0;
          if (active_view !== "CD") {
            if (state_lds[`${state}_${active_view}`] === void 0) {
              load_time = 50;
              load_districts(add_leading_digits(selected_state.id, 2), state);
            } else {
              enable_district(state_lds[`${state}_${active_view}`]);
            }
          } else {
            district_data = topojson.feature(districts, districts.objects.districts).features.filter(function(a) {
              return parseInt(a.id / 100) === d.id;
            });
            districts_g.data(district_data).enter().append("path").attr("d", path).attr("id", function(d) {
              return 'id_' + String(d.id);
            }).classed("district", true).classed("active", function(d) {
              var ref;
              return ref = d.id, indexOf.call(one_district, ref) >= 0;
            }).on("click", check_district);
            district_borders_g.datum(topojson.mesh(districts, districts.objects.districts, function(a, b) {
              return a !== b && (a.id / 1000 | 0) === (b.id / 1000 | 0) && parseInt(a.id / 100) === d.id && parseInt(b.id / 100) === d.id;
            })).attr("d", path);
          }
        } else {
          // Display the state only
          wrapper_g.selectAll(".state").classed("active", false).classed("shape-on", selected_state && function(d) {
            return d === selected_state;
          });
        }
        update_filter();
        z_duration = allow_panning ? 750 : 0;
        // if first load wait so there is no jump
        setTimeout((function() {
          var bounds, dx, dy, translate, x, y;
          bounds = path.bounds(d);
          dx = bounds[1][0] - bounds[0][0];
          dy = bounds[1][1] - bounds[0][1];
          x = (bounds[0][0] + bounds[1][0]) / 2;
          y = (bounds[0][1] + bounds[1][1]) / 2;
          scale = .9 / Math.max(dx / width, dy / height);
          translate = [width / 2 - (scale * x), height / 2 - (scale * y)];
          wrapper_g.transition().duration(z_duration).attr('transform', 'translate(' + translate + ')scale(' + scale + ')');
          // if allow_panning or first_load
          if (active_view !== "" && active_view !== "stateboth" && active_view !== "everyone") {
            draw_cities(state);
          } else {
            wrapper_g.selectAll("circle").remove();
            d3.selectAll(".circle-label").remove();
          }
          wrapper_g.selectAll(".state, .state-borders").classed("zoom-in", true);
          if (first_load) {
            first_load = false;
          }
        // view_change = false
        }), load_time);
      }
    };
    load_districts = function(state_num, state_id) {
      d3.json(STATIC_URL + `data/state_geos/${active_view}_small_topos/topo_tl_2014_${state_num}_${active_view}.static`, function(error, data) {
        state_lds[`${state_id}_${active_view}`] = data;
        return enable_district(data);
      });
    };
    enable_district = function(dist_shapes) {
      var district_data;
      district_data = topojson.feature(dist_shapes, d3.values(dist_shapes.objects)[0]).features;
      districts_g.data(district_data).enter().append("path").attr("d", path).attr("id", function(d) {
        return 'id_' + String(d.id);
      }).classed("district", true).classed("active", function(d) {
        var ref;
        return ref = d.id, indexOf.call(one_district, ref) >= 0;
      }).on("click", check_district);
      // district borders
      district_borders_g.datum(topojson.mesh(dist_shapes, d3.values(dist_shapes.objects)[0], function(a, b) {
        return a !== b;
      })).attr("d", path);
    };
    check_district = function(d) {
      var state_name;
      address = '';
      selected_address = '';
      // If click on new district and there are multiple districts, then make active, select it, and update
      if (d === selected_district || d.id % 100 === 0 || d.id === 1198) {
        if (!Userdata.isSingleRegionMode()) {
          return reset_zoom();
        }
      } else {
        d3.selectAll(".districts path").classed("active", false);
        if (chamber === "fedboth" || chamber === "" || chamber === "house" || chamber === "senate") {
          if (this.id != null) {
            d3.select(this).classed("active", true);
          } else {
            d3.select("#id_" + String(district_tag)).classed("active", true);
          }
          // when the user clicks on a district, it should switch to that mode
          $("#chamber_select").select2("val", "house");
          chamber = "house";
          selected_district = d;
          if (selected_district.id > 999) {
            district = +selected_district.id.toString().slice(2, 4);
          } else {
            district = +selected_district.id.toString().slice(1, 3);
          }
          // update currently selected
          d3.select(".currently-selected").html('<hr> <span class="title">Currently Selected:</span> <h3><span id="currently_selected">' + state + '-' + district + '</span></h3> <hr>');
        } else {
          if (this.id != null) {
            d3.select(this).classed("active", true);
          } else {
            d3.select("#id_" + String(district_tag)).classed("active", true);
          }
          selected_district = d;
          district = d.properties.full_id;
          state_name = DjangIO.app.models.Region.items().filter(item(() => {
            return item.abbrev === state.toLowerCase();
          }))[0].region_name;
          d3.select(".currently-selected").html('<hr> <span class="title">Currently Selected:</span> <h3><span id="currently_selected">' + state_name + "<br>" + d.properties.name + '</span></h3> <hr>');
        }
        return update_filter();
      }
    };
    reset_zoom = function() {
      selected_state = null;
      selected_district = null;
      state = '';
      district = '';
      address = '';
      update_filter();
      if (allow_panning) {
        wrapper_g.selectAll("circle").remove();
        d3.selectAll(".circle-label").remove();
      }
      // hide zoom-out button
      d3.select("#zoom-out").style("display", "none");
      // reset the selectors
      d3.selectAll('.district').remove();
      if (district_borders_g) {
        district_borders_g.attr("d", "");
      }
      d3.select(".currently-selected").html('<hr> <span class="title">Currently Selected:</span> <h3><span id="currently_selected">All</span></h3> <hr>');
      wrapper_g.transition().duration(750).attr("transform", "translate(0,0)scale(1,1)");
      wrapper_g.selectAll(".state, .state path").classed("active", false).classed("shape-on", false);
      return wrapper_g.selectAll(".state, .state-borders").classed("zoom-in", false);
    };
    draw_cities = function(state) {
      var cities, city_name_size, city_name_sizer, city_names, city_size, city_sizer, num_cities;
      if (state !== "DC") {
        d3.selectAll(".circle-label").remove();
        d3.selectAll(".circle:not(#pip-drop)").remove();
        num_cities = top_cities[state].length;
        cities = wrapper_g.selectAll("circle").data(top_cities[state].filter(function(d) {
          if (d.zoom_level === 1) {
            return d;
          }
        }));
        cities.enter().append("circle");
        city_sizer = 1.000 / num_cities;
        city_size = 1.500;
        cities.attr("r", function(d) {
          return city_size / Math.log(scale);
        }).attr("opacity", 0).attr("id", function(d) {
          return String(d.city);
        }).attr("stroke", pinpoint_stroke).style("fill", "#3d3262").attr("stroke-width", function(d) {
          return 1 / scale;
        }).attr("transform", function(d) {
          var proj;
          proj = projection([parseFloat(d['location'][0]), parseFloat(d['location'][1])]);
          return "translate(" + proj[0] + "," + proj[1] + ")";
        });
        city_names = wrapper_g.selectAll("circle-label").data(top_cities[state].filter(function(d) {
          if (d.zoom_level === 1) {
            return d;
          }
        }));
        city_name_sizer = 2 / num_cities;
        city_name_size = 5.500;
        city_names.enter().append("text").attr("id", function(d) {
          return String(d.placement);
        }).attr("class", "circle-label").attr("transform", function(d) {
          var proj;
          proj = projection([parseFloat(d['location'][0]), parseFloat(d['location'][1])]);
          return "translate(" + proj[0] + "," + proj[1] + ")";
        }).attr("dy", function(d) {
          if (d.placement === 'right') {
            return ".35em";
          } else {
            return ".35em";
          }
        }).attr("dx", function(d) {
          if (d.placement === 'right') {
            return ".55em";
          } else {
            return "-.5em";
          }
        }).text(function(d) {
          return d.city;
        }).attr("font-size", function(d) {
          city_name_size = city_name_size - city_name_sizer;
          return city_name_size / Math.log(scale);
        });
        d3.selectAll(".circle-label").style("text-anchor", function(d) {
          if (d.placement === 'right') {
            return "start";
          } else {
            return "end";
          }
        }).style("fill", "white").style("text-shadow", "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000").style("pointer-events", "none").style("font-weight", 700).attr("opacity", 0);
        city_names.transition().duration(750).attr('opacity', 1);
        cities.transition().duration(750).attr("opacity", 1);
        cities.exit().remove();
        return city_names.exit().remove();
      }
    };
    add_leading_digits = function(numstr, str_len) {
      if (typeof numstr !== "string") {
        numstr = String(numstr);
      }
      if (numstr.length > str_len) {
        console.log("This number is longer then the intended string, try again");
        return;
      }
      while (numstr.length < str_len) {
        numstr = "0" + numstr;
      }
      return numstr;
    };
    // getters and setters for internal variables
    map.set_chamber = function(new_chamber) {
      if (new_chamber !== chamber) {
        if (new_chamber === "house" || new_chamber === "senate" || new_chamber === "fedboth") {
          active_view = "CD";
        } else {
          active_view = new_chamber;
        }
        chamber = new_chamber;
        return update();
      }
    };
    map.get_current_state = function() {
      return filter_dict;
    };
    map.set_party = function(new_party) {
      if (new_party !== party) {
        party = new_party;
        return update();
      }
    };
    map.set_viewpoint = function(new_view) {
      if (new_view !== active_view) {
        active_view = new_view;
        view_change = true;
        return update();
      }
    };
    map.set_state = function(new_state) {
      if (new_state !== state) {
        state = new_state;
        return update();
      }
    };
    // search function
    map.updateSearch = function(searchTerm) {
      if (search_term !== searchTerm) {
        search_term = searchTerm;
        update();
      }
      return false;
    };
    // address function
    map.set_address = function(new_address) {
      if (address !== new_address) {
        if (address !== '') {
          $("#chamber_select").select2("val", "house");
          chamber = "house";
        }
        address = new_address;
        update();
      }
      return false;
    };
    map.reset = function() {
      return reset_zoom();
    };
    // final act of DistrictMap() function is to return the inner map function
    return map;
  };

  module.exports = {
    DistrictMap: DistrictMap
  };

}).call(globalThis);
